import { RECEIVE_RESULT, REQUEST_RESULT, SET_RESULT_ERROR, RESET_RESULT_DATA } from '../constants/ActionTypes';

const initialState = {
	isFetching: false,
	isLoadingError: false
};

export default function currentResult(state = initialState, action) {
	switch (action.type) {
		case SET_RESULT_ERROR:
			return {
				...state,
				isFetching: false,
				isLoadingError: true
			};
		case REQUEST_RESULT:
			return {
				...state,
				isFetching: true,
				isLoadingError: false
			};
		case RECEIVE_RESULT:
			return {
				...state,
				isFetching: false,
				resultData: {
					...state.resultData,
					...action.data
				}
			};
		case RESET_RESULT_DATA:
			return {
				...state,
				resultData: null
			};
		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/reducers/currentResult.js